import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/types";
import { Button, Form, Table } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import tableUtils from "../../../utils/tableUtils";
import { useCreateServiceCenterMutation, useDeleteServiceCenterMutation, useGetServiceCentersQuery, useUpdateServiceCenterMutation } from "../../../services/serviceCenter";
import HrnModal from "../../../components/HrnModal";
import validateMessages from "../../../utils/validate";
import ServiceCenterForm from "./ServiceCenterForm";
import { Actions } from "../../../shared/constants";
import { useState } from "react";
import dayjs from "dayjs";

const ServiceCentersColumn: any[] = [
    {
        key: "name",
        header: "Name",
        className: " font-medium",
        responsive: ["xs"],
        fn: (value: any, record: any) => (<>
            <div className="text-primary">{record.name}</div>
            <div>{record.hotlineNo}</div>
            <div>{record.email}</div>
        </>)
    },
    {
        key: "name",
        header: "Name",
        className: "text-primary font-medium",
        responsive: ["sm", "md", "lg", "xl", "xxl"],

    },
    { key: "hotlineNo", header: "Hotline No.", responsive: ["sm", "md", "lg", "xl", "xxl"], className: "font-medium" },
    { key: "email", header: "Email", responsive: ["sm", "md", "lg", "xl", "xxl"], className: "font-medium" },
];

const ServiceCenter = ({ companyId, insideTab }: { companyId?: string, insideTab?: boolean }) => {
    const { loggedInUser } = useSelector((state: RootState) => state.global);
    const [serviceCenterForm] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState("");
    const [editId, setEditId] = useState("");
    const {
        data: serviceCenters,
        isFetching: isSCFetching,
        isSuccess: isSCSuccess,
    } = useGetServiceCentersQuery({
        companyId: companyId || loggedInUser?.currentCompany?.id
    });

    const [createServiceCenter, createSCResult] = useCreateServiceCenterMutation();
    const [updateServiceCenter, updateSCResult] = useUpdateServiceCenterMutation();
    const [deleteServiceCenter, deleteSCResult] = useDeleteServiceCenterMutation();

    const showModal = () => {
        setMode(Actions.CREATE);
        setOpen(true);
    };

    const hideModal = () => {
        setOpen(false);
        serviceCenterForm.resetFields();
        setMode("");
    };

    const onSave = async () => {
        try {
            await serviceCenterForm.validateFields();
        } catch (errorInfo) {
            return;
        }

        const formFields = serviceCenterForm.getFieldsValue();

        if (mode === Actions.CREATE) {
            try {
                await createServiceCenter({
                    companyId: companyId || loggedInUser?.currentCompany?.id,
                    body: {
                        ...formFields,
                        workingHour: undefined,
                        workingStartTime: formFields.workingHour?.[0],
                        workingEndTime: formFields.workingHour?.[1],
                    }
                }).unwrap();
                setOpen(false);
                serviceCenterForm.resetFields();
            } catch (e) { }
        } else {
            try {
                await updateServiceCenter({
                    companyId: companyId || loggedInUser?.currentCompany?.id,
                    id: editId,
                    body: {
                        ...formFields,
                        workingHour: undefined,
                        workingStartTime: formFields.workingHour?.[0],
                        workingEndTime: formFields.workingHour?.[1],
                    }
                }).unwrap();
                setOpen(false);
                serviceCenterForm.resetFields();
            } catch (e) {

            }
        }
    };

    const handleEdit = (record: any) => {
        setMode(Actions.EDIT);
        setOpen(true);
        if (record.id) setEditId(record.id);
        serviceCenterForm.setFieldsValue({
            ...record,
            workingHour: [record?.workingStartTime && dayjs(record.workingStartTime + "Z"), record?.workingEndTime && dayjs(record.workingEndTime + "Z")]
        });
    };

    const handleDelete = async (record: any) => {
        try {
            await deleteServiceCenter({
                companyId: loggedInUser?.currentCompany?.id,
                id: record.id
            }).unwrap();
        } catch (e) { }
    };

    return (
        <>
            <div className="flex justify-between items-center gap-3 pb-1">
                <div className="text-headline">{!insideTab ? "Service Centers" : ""}</div>
                <Button type="primary" className="flex-end" onClick={showModal}>
                    <PlusOutlined /> Add
                </Button>
            </div>
            <div>
                <Table
                    rowKey="id"
                    showHeader={insideTab}
                    columns={tableUtils.buildColumns(
                        isSCSuccess ? serviceCenters : [],
                        ServiceCentersColumn,
                        tableUtils.editDeleteActionColumns(handleEdit, handleDelete)
                    )}
                    dataSource={serviceCenters}
                    size="middle"
                    className="ant_table"
                    loading={{
                        spinning: isSCFetching as boolean,
                        indicator: <LoadingOutlined style={{ fontSize: 34 }} />,
                    }}
                    pagination={false}
                />
            </div>
            <div>
                <HrnModal
                    open={open}
                    title={`${mode === Actions.CREATE ? "Add" : "Edit"} Service Center`}
                    width={520}
                    isLoading={
                        (createSCResult.isLoading ||
                            updateSCResult.isLoading) as boolean
                    }
                    onCancel={hideModal}
                    onSave={onSave}
                >
                    <div className="mt-6">
                        <Form
                            form={serviceCenterForm}
                            layout="vertical"
                            name="serviceCenterForm"
                            validateMessages={validateMessages}
                        >
                            <ServiceCenterForm mode={mode} form={serviceCenterForm} />
                        </Form>
                    </div>
                </HrnModal>
            </div>
        </>
    );
};

export default ServiceCenter;